export const loadingReducer = (prevState={isLoading:false}, action) => {
    const {type,payload} = action
    let newState = {...prevState}
    switch(type){
        case 'loading_change':
            newState.isLoading = payload
            return newState
        default:
            return prevState
    }
}